import _ from 'lodash';

function MLProducerUtil() {
    const getProducerCodeDisplayName = (producer) => {
        const displayName = (strings, lastName, firstName, code) => {
            const retval = [];
            const comma = strings[1];
            const hyphen = strings[2];

            if (lastName) {
                retval.push(_.capitalize(lastName));
            }

            if (firstName) {
                if (lastName) {
                    retval.push(`${comma} `);
                }
                retval.push(_.capitalize(firstName));
            }
            if (lastName) {
                retval.push(` ${hyphen} `);
            }
            retval.push(code);
            return retval.join('');
        };
        return displayName`${producer.producerContactLastName_ML}, ${producer.producerContactFirstName_ML} - ${producer.code}`;
    };

    const getProducerCodeDisplayNameByCode = (code, user) => {
        const defaultDisplayName = '-';
        const selectedProducerCode = user.producerCodes_ML.find((producerCode) => producerCode.code === code);
        if (selectedProducerCode) {
            return getProducerCodeDisplayName(selectedProducerCode);
        }
        return defaultDisplayName;
    };

    return {
        getProducerCodeDisplayName: getProducerCodeDisplayName,
        getProducerCodeDisplayNameByCode: getProducerCodeDisplayNameByCode
    };
};
export default MLProducerUtil;